import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { TimeSerieFileDateCard } from "./card";

import { TimeSerieFileDatesTable } from "./table";

export default function TimeSerieFileDates() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Dates des fichiers de séries temporelles");
  }, []);

  return (
    <Routes>
      <Route index element={<TimeSerieFileDatesTable />} />
      <Route path=":id" element={<TimeSerieFileDateCard />} />
    </Routes>
  );
}
